<template>
  <div class="tw-flex tw-items-center tw-space-x-4">
    <img
      v-if="isGoogleReview"
      :src="review.avatar"
      class="tw-h-10 tw-min-h-[2.5rem] tw-w-10 tw-min-w-[2.5rem]"
      :alt="review.customer_name"
    />

    <Avatar
      v-else
      :name="review.customer_name"
      shape="circle"
      size="large"
      :pt="{
        label: {
          class: 'tw-text-white tw-font-400 tw-text-lg',
        },
      }"
    />

    <div class="tw-flex tw-flex-col tw-overflow-hidden">
      <div
        class="tw-flex-inline tw-flex tw-cursor-default tw-items-center tw-space-x-2 tw-text-base tw-font-bold tw-text-gray-700"
      >
        <span>{{ review.customer_name }}</span>

        <img
          v-if="isGoogleReview"
          :src="asset('/assets/site/images/svg/google.svg')"
          class="tw-h-4 tw-min-h-[1rem] tw-w-4 tw-min-w-[1rem]"
          alt="Google"
        />

        <font-awesome-icon
          v-else
          :icon="['fas', 'check-circle']"
          class="tw-mr-2 tw-h-4 tw-w-4"
          :style="{ color: $page.props.customisation.secondary_background }"
        />
      </div>
      <span class="tw-text-sm tw-font-normal tw-text-gray-400">{{ review.submitted_on }}</span>
    </div>
  </div>
  <div class="tw-mt-4 tw-flex tw-items-center tw-gap-2.5" :class="{ 'tw-pb-2': !showServiceName }">
    <RatingStars :highlightedNumbers="review.rating" :starCount="totalStars" class="tw-text-sm" />
    <template v-if="showServiceName">
      <Tag
        :value="serviceDisplayName"
        rounded
        class="!tw-justify-normal tw-truncate tw-border tw-border-gray-300 !tw-bg-gray-50 !tw-px-3 !tw-py-1.5 !tw-font-medium !tw-text-gray-500"
        v-tooltip.top="{ value: serviceDisplayName, class: '!tw-text-xs' }"
        :pt="{
          label: {
            class: 'tw-truncate',
          },
        }"
      ></Tag>
    </template>
  </div>
  <div v-if="review.feedback" class="tw-whitespace-pre-line tw-pt-3 tw-text-sm tw-font-normal">
    <p
      v-if="showEllipsis"
      v-snip="{ lines: lines, onSnipped: onSnipped, mode: 'js' }"
      class="tw-text-sm tw-font-medium tw-text-gray-700"
    >
      {{ review.feedback }}
    </p>
    <p v-else>
      {{ review.feedback }}
    </p>
    <a
      href
      class="tw-mt-4 tw-w-fit tw-underline"
      :style="{ color: $page.props.customisation.secondary_background }"
      v-if="review.feedback && showEllipsis && hasEllipsis"
      @click.prevent="readMore()"
    >
      Read more
    </a>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  review: Object,
});

let hasEllipsis = ref(true);
let showEllipsis = ref(true);

const lines = 8;
const totalStars = 5;

const onSnipped = newState => {
  hasEllipsis.value = newState.hasEllipsis;
};

const readMore = () => {
  showEllipsis.value = false;
};

const isGoogleReview = computed(() => props.review.origin === 'google');

const serviceDisplayName = computed(() => {
  return props.review.parent_service_name
    ? props.review.parent_service_name + ' - ' + props.review.service_name
    : props.review.service_name;
});

const showServiceName = computed(() => !!props.review.service_name);
</script>
